import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { format } from 'date-fns';

import { GetSessions } from '../../actions/sessions';
import { selectDate } from '../../actions/date_nav';

import Calendar from './calendar';
import PrintBtn from './presentational/print_btn';

class TopBarComponent extends PureComponent {
  static propTypes = {
    device: PropTypes.string.isRequired,
    date: PropTypes.instanceOf(Date).isRequired,
    GetSessionsData: PropTypes.func.isRequired,
    printUrl: PropTypes.string.isRequired,
    SelectDate: PropTypes.func.isRequired,
  };

  render() {
    const { printUrl } = this.props;
    return (
      <div className="clearfix calendar-bar">
        <Calendar {...this.props} />
        <PrintBtn url={printUrl} />
      </div>
    );
  }
}

const mapStateToProps = ({ general, sessions }) => ({
  printUrl: general.print.replace(':date', format(sessions.selectedDate, 'YYYY/MM/DD')),
  date: sessions.selectedDate,
  device: general.device,
});

const mapDispatchToProps = dispatch => ({
  GetSessionsData: date => dispatch(GetSessions(date)),
  SelectDate: date => dispatch(selectDate(date)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopBarComponent);
